import React, { Component } from 'react'
import { withStyles } from '@material-ui/core';
import UsernameRegistration from './StepOne/UsernameRegistration';
import UsernameRegistrationHostel from './StepOne/UsernameRegistrationHostel';

const styles = theme => ({

})

class RegistrationLandingHostel extends Component {
    render() {
        let { classes } = this.props;
        return (
            <div>
                <UsernameRegistrationHostel
                    history={this.props.history}
                />
            </div>
        )
    }
}

export default withStyles(styles)(RegistrationLandingHostel)